import { useEffect, useState } from "react";
import {
  TopToolbar,
  CreateButton,
  FilterButton,
  useDataProvider,
  useCreatePath,
  useResourceContext,
} from "react-admin";
import { CampaignSubTypes } from "utils/constants";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { ExportXlsButton } from "./ExportXlsxButton";
import { candidateRequests } from "api/candidateApi";
import { useNotifyError } from "utils/useNotifyError";

const CampaignTopToolbar = ({ campaignSubType, campaignIds, exporter, empty = false }) => {
  const isPaid = campaignSubType === CampaignSubTypes.Paid;
  const dataProvider = useDataProvider();
  const notifyError = useNotifyError();
  const [citizenIds, setCitizenId] = useState(null);

  // The list is rendered as a tab of CandidatesPage (route /candidate/candidacies), while its
  // create route lives under the candidacy resource itself. A relative "create?type=..." would
  // resolve against the tabs route and 404 — build the absolute path from the resource context.
  const resource = useResourceContext();
  const createPath = useCreatePath();
  const createTo = type => `${createPath({ resource, type: "create" })}?type=${type}`;

  useEffect(() => {
    if (isPaid) return;

    const fetchCitizenship = async () => {
      try {
        const res = await dataProvider.customRequest(candidateRequests.getCampaignCitizenship(campaignIds));
        setCitizenId(res.data);
      } catch (error) {
        notifyError(error);
      }
    };
    fetchCitizenship();
  }, [campaignIds, dataProvider, isPaid, notifyError]);

  return (
    <TopToolbar
      sx={{
        gap: "1rem",
        // Up to three long "Създай кандидатура за …" buttons + Filter + Export: wrap them onto
        // a new row on narrower screens instead of forcing a horizontal scroll.
        flexWrap: "wrap",
        justifyContent: empty ? "center" : "end",
        padding: empty ? "2rem" : "",
        background: empty ? "#a5a1a121" : "",
        marginBottom: "1rem",
        marginTop: "1rem",
      }}
    >
      <SecuredComponent permission={permissions.canCreateCandidacy}>
        {(campaignSubType === CampaignSubTypes.Regular && citizenIds?.length > 0) ||
        campaignSubType === CampaignSubTypes.Paid ? (
          <>
            {(citizenIds && citizenIds.includes(1)) || isPaid ? (
              <CreateButton
                variant="contained"
                label="Създай кандидатура за българин"
                to={createTo("Bg")}
              />
            ) : null}
            {citizenIds && citizenIds.includes(2) && !isPaid ? (
              <CreateButton
                variant="contained"
                label={`Създай кандидатура за чужденец ЕС`}
                to={createTo("Es")}
              />
            ) : null}
            {citizenIds && citizenIds.includes(3) && !isPaid ? (
              <CreateButton
                variant="contained"
                label={`Създай кандидатура за чужденец извън ЕС`}
                to={createTo("En")}
              />
            ) : null}
          </>
        ) : null}
      </SecuredComponent>
      {!empty ? (
        <>
          <FilterButton variant="outlined" />
          <ExportXlsButton
            exporter={exporter}
            variant="outlined"
          />
        </>
      ) : null}
    </TopToolbar>
  );
};

export default CampaignTopToolbar;
